import { useStore } from 'react-admin';

export const useMapOpacity = (): [number] => {
  const [mapOpacity] = useStore<number>('map.opacity', 0.5);
  return [mapOpacity];
}
